import { render, staticRenderFns } from "./IssueBox.vue?vue&type=template&id=3b7f660f&scoped=true&"
import script from "./IssueBox.vue?vue&type=script&lang=js&"
export * from "./IssueBox.vue?vue&type=script&lang=js&"
import style0 from "./IssueBox.vue?vue&type=style&index=0&id=3b7f660f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f660f",
  null
  
)

export default component.exports